(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vega-mobile-nav"] && !Shopify.designMode) return;
  try {
    /* VEGA: respaldo del sticky "Añadir al carrito".
     El observer nativo de Prestige (que agrega .is-visible a <product-sticky-bar>)
     no estaba disparando en Dev_Current, así que el botón desaparecía al scrollear.
     Este script muestra el sticky ATC siempre que el botón de compra PRINCIPAL
     esté fuera del viewport — igual que la barra de "Cotizar por Mayoreo".
     Re-consulta los elementos en cada frame para sobrevivir los re-renders
     (<product-rerender>) al cambiar de variante. */
  (function () {
    function update() {
      var bar = document.querySelector('product-sticky-bar');
      if (!bar) return;
      // El <buy-buttons> principal = el que NO está dentro del sticky bar.
      var buys = document.querySelectorAll('buy-buttons');
      var main = null;
      for (var i = 0; i < buys.length; i++) {
        if (!bar.contains(buys[i])) { main = buys[i]; break; }
      }
      if (!main) { bar.classList.remove('is-visible'); return; }
      var r = main.getBoundingClientRect();
      var inView = r.top < window.innerHeight && r.bottom > 0;
      bar.classList.toggle('is-visible', !inView);
    }
    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('DOMContentLoaded', update);
    document.addEventListener('shopify:section:load', update);
    if (document.readyState !== 'loading') update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vega-price-cents"] && !Shopify.designMode) return;
  try {
    (function () {
    // Nota: se EXCLUYE .cart-drawer__button-price (total del botón "Finalizar compra"):
    // ese botón usa un layout flex de dos partes y el <sup> se desacomodaba.
    // Incluye free-shipping-bar (mensaje "Agrega $X para conseguir Envío Gratis").
    var SELECTOR = 'sale-price, compare-at-price, unit-price, .price-list__savings, free-shipping-bar';
    // Separador decimal (punto O coma) seguido de EXACTAMENTE 2 dígitos (centavos) no
    // seguidos de otro dígito. El separador de miles va seguido de 3 dígitos, así que
    // el lookahead lo excluye — solo captura los centavos, nunca los miles.
    var CENTS_RE = /[.,](\d{2})(?!\d)/;

    function processEl(el) {
      var currentText = el.textContent;
      if (el.__vcText === currentText) return; // sin cambios desde el último procesado

      // limpiar wraps previos (por si el precio cambió: variante, cantidad…)
      var olds = el.querySelectorAll('sup.vega-cents');
      for (var i = 0; i < olds.length; i++) {
        olds[i].replaceWith(document.createTextNode(olds[i].textContent));
      }
      el.normalize();

      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var targets = [], tn;
      while ((tn = walker.nextNode())) {
        if (CENTS_RE.test(tn.nodeValue)) targets.push(tn);
      }
      for (var j = 0; j < targets.length; j++) {
        var node = targets[j], t = node.nodeValue, m = t.match(CENTS_RE);
        if (!m) continue;
        var idx = m.index;
        var sup = document.createElement('sup');
        sup.className = 'vega-cents';
        sup.textContent = m[0]; // ".XX"
        var after = document.createTextNode(t.slice(idx + m[0].length));
        node.nodeValue = t.slice(0, idx);
        node.parentNode.insertBefore(sup, node.nextSibling);
        node.parentNode.insertBefore(after, sup.nextSibling);
      }
      el.__vcText = el.textContent;
    }

    function run() {
      var els = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < els.length; i++) processEl(els[i]);
    }

    var scheduled = false, obs;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        if (obs) obs.disconnect();
        run();
        if (obs) obs.observe(document.body, { childList: true, subtree: true, characterData: true });
        scheduled = false;
      });
    }
    function init() {
      run();
      obs = new MutationObserver(schedule);
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vega-product-tabs"] && !Shopify.designMode) return;
  try {
    /* VEGA: lightbox de la etiqueta nutrimental. Toca la etiqueta → abre a pantalla
     completa; toca la imagen → alterna zoom a tamaño real (arrastra para leer). */
  (function () {
    var lb, img, stage;

    function ensure() {
      if (lb) return;
      lb = document.createElement('div');
      lb.className = 'vega-lightbox';
      lb.setAttribute('hidden', '');
      lb.innerHTML =
        '<button type="button" class="vega-lightbox__close" aria-label="Cerrar">×</button>' +
        '<div class="vega-lightbox__stage"><img class="vega-lightbox__img" alt="Etiqueta e información nutrimental"></div>' +
        '<span class="vega-lightbox__hint">Toca la imagen para acercar · arrastra para mover</span>';
      document.body.appendChild(lb);
      img = lb.querySelector('.vega-lightbox__img');
      stage = lb.querySelector('.vega-lightbox__stage');
      lb.querySelector('.vega-lightbox__close').addEventListener('click', close);
      stage.addEventListener('click', function (e) { if (e.target === stage) close(); });
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        img.classList.toggle('is-zoomed');
        if (!img.classList.contains('is-zoomed')) { stage.scrollTop = 0; stage.scrollLeft = 0; }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    function open(src) {
      if (!src) return;
      ensure();
      img.classList.remove('is-zoomed');
      img.src = src;
      stage.scrollTop = 0; stage.scrollLeft = 0;
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (!lb) return;
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.vega-nutrition-open') : null;
      if (btn) { e.preventDefault(); open(btn.getAttribute('data-full')); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vega-rewards-js"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Confeti (canvas, sin librerías) */
    function vegaConfetti() {
      var canvas = document.createElement('canvas');
      /* z-index máximo: el cart-drawer del tema llega a ~1e9, hay que quedar por encima */
      canvas.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483647';
      document.body.appendChild(canvas);
      var ctx = canvas.getContext('2d');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      var colors = ['#cb2b2b', '#1a8a3c', '#f5b301', '#2b7fcb', '#ff7ab0', '#ffffff'];
      var parts = [];
      for (var i = 0; i < 150; i++) {
        parts.push({
          x: window.innerWidth / 2, y: window.innerHeight * 0.42,
          vx: (Math.random() - 0.5) * 15,
          vy: Math.random() * -15 - 4,
          g: 0.30 + Math.random() * 0.2,
          s: 5 + Math.random() * 6,
          rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4,
          c: colors[(Math.random() * colors.length) | 0]
        });
      }
      var start = null;
      function frame(t) {
        if (!start) start = t;
        var el = t - start;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var alive = false;
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          p.vy += p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.vx *= 0.99;
          if (p.y < canvas.height + 30) alive = true;
          ctx.save();
          ctx.translate(p.x, p.y); ctx.rotate(p.rot);
          ctx.globalAlpha = Math.max(0, 1 - el / 2700);
          ctx.fillStyle = p.c;
          ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6);
          ctx.restore();
        }
        if (alive && el < 2900) { window.requestAnimationFrame(frame); }
        else { canvas.remove(); }
      }
      window.requestAnimationFrame(frame);
    }

    var lastReached = null;
    var removing = false;

    function readReached() {
      var bar = document.querySelector('.vega-rewards');
      return bar ? parseInt(bar.getAttribute('data-reached') || '0', 10) : 0;
    }

    /* Fija la línea base de INMEDIATO al cargar (aunque el carrito esté vacío),
       para no perder el primer cruce de nodo. */
    function baseline() { if (lastReached === null) lastReached = readReached(); }

    function autoRemoveGift(bar) {
      if (removing) return;
      var unlocked = bar.getAttribute('data-gift-unlocked') === 'true';
      var hasGift = bar.getAttribute('data-has-gift') === 'true';
      var key = bar.getAttribute('data-gift-key');
      var staleKey = bar.getAttribute('data-stale-gift-key');
      var target = null;

      /* 1) Regalo de una promo ANTERIOR (otro producto): el BXGY ya no lo
            descuenta, se le cobraría al cliente. Fuera siempre. */
      if (staleKey) {
        target = staleKey;
      /* 2) Regalo vigente pero el carrito ya no alcanza el umbral. Solo se
            retira la línea que puso el botón, nunca una que el cliente compró. */
      } else if (!unlocked && hasGift && key) {
        target = key;
      }
      if (!target) return;

      removing = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: target, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* El tema espera detail.cart; un evento vacío hacía tronar
             CartDrawer.onCartChange. Con el detalle correcto, refresca bien. */
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart, baseEvent: 'vega-gift-remove' } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          removing = false;
        })
        .catch(function () { removing = false; });
    }

    function check() {
      var reached = readReached();
      if (lastReached !== null && reached > lastReached) { vegaConfetti(); }
      lastReached = reached;
      var bar = document.querySelector('.vega-rewards');
      if (bar) autoRemoveGift(bar);
    }

    var t;
    function schedule() { clearTimeout(t); t = setTimeout(check, 120); }

    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', baseline);
    } else {
      baseline();
    }

    /* Respaldo: observar re-render del carrito (drawer) */
    var obs = new MutationObserver(function () { schedule(); });
    obs.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
